module.exports = __webpack_public_path__ + "media/images/icons/material/school-6d2133eb586d48985031aea351173fb3.svg";